module.exports = __webpack_public_path__ + "static/flux-hifi-4-b25dccef9cffc42fd68ebfdda35db8ac.jpg";